import React, { useContext } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Observer } from "mobx-react-lite";
import FlowstationPerformanceStore from "../../store/FlowstationPerformanceStore";
import { createContext } from "react";

import "highcharts/modules/drilldown.js";
import "highcharts/modules/data.js";
import "highcharts/modules/exporting.js";
import "highcharts/modules/export-data.js";
import { toJS } from "mobx";
import { Skeleton } from "antd";
const flowstationPerformanceStoreCtx = createContext(
  FlowstationPerformanceStore
);
export const FlowstationCapacityUtilization = () => {
  const flowstationPerformanceStore = useContext(
    flowstationPerformanceStoreCtx
  );

  return (
    <Observer>
      {() =>
        flowstationPerformanceStore.isLoading ? (
          <>
            <div style={{ padding: "15px" }}>
              <Skeleton active />
              <Skeleton active />
              <Skeleton active />
            </div>
          </>
        ) : (
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              chart: {
                type: "column",
              },
              credits: {
                enabled: true,
                text: "source: SPARS",
                href: "mailto:projects@cybersprintitsolutions.com",
              },

              title: {
                style: { fontSize: "14px" },
                text: `<b>Flowstation Capacity Utilization (%) </b><br/>${flowstationPerformanceStore.selMonthName},${flowstationPerformanceStore.selYear}`,
              },

              xAxis: {
                categories: [
                  ...flowstationPerformanceStore.flowstationUtilization.values(),
                ].map((x) => toJS(x.flowstation)),
                crosshair: true,
                title: {
                  text: "Flowstation",
                },
              },

              yAxis: {
                min: 0,
                title: {
                  text: "Capacity Utilization (%)",
                },
                max: 100,
              },
              dataLabels: {
                enabled: true,
              },
              legend: {
                align: "right",
                x: -30,
                verticalAlign: "top",
                y: 25,
                floating: true,
                backgroundColor:
                  Highcharts.defaultOptions.legend.backgroundColor || "white",
                borderColor: "#CCC",
                borderWidth: 1,
                shadow: false,
              },

              series: [
                {
                  name: "Oil Utilization (%)",
                  data: [
                    ...flowstationPerformanceStore.flowstationUtilization.values(),
                  ].map((x) => Math.round(toJS(x.oilUtilization))),
                  color: "red",
                  dataLabels: { enabled: true },
                },
                {
                  name: "Gas Utilization (%)",
                  data: [
                    ...flowstationPerformanceStore.flowstationUtilization.values(),
                  ].map((x) => Math.round(toJS(x.gasUtilization))),
                  color: "darkgreen",
                  dataLabels: { enabled: true },
                },
              ],
              responsive: {
                rules: [
                  {
                    condition: {
                      maxWidth: 1000,
                    },
                    chartOptions: {
                      legend: {
                        floating: false,
                        layout: "horizontal",
                        align: "center",
                        verticalAlign: "bottom",
                        x: 0,
                        y: 0,
                      },
                      yAxis: [
                        {
                          labels: {
                            align: "right",
                            x: 0,
                            y: -6,
                          },
                          showLastLabel: false,
                        },
                        {
                          labels: {
                            align: "left",
                            x: 0,
                            y: -6,
                          },
                          showLastLabel: false,
                        },
                        {
                          visible: false,
                        },
                      ],
                    },
                  },
                ],
              },
            }}
          />
        )
      }
    </Observer>
  );
};

